import {defineStyle, defineStyleConfig} from '@chakra-ui/styled-system';

// Default styles
// https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/form-label.ts

const baseStyle = defineStyle({
  fontSize: `sm`,
  mb: `space-100`,
  fontWeight: `400`,
  color: `text.secondary`,
  transitionProperty: `common`,
  transitionDuration: `normal`,
  cursor: `pointer`,
  _disabled: {
    cursor: `default`,
    opacity: 1,
  },
});

export const formLabelTheme = defineStyleConfig({
  baseStyle,
});
